module.exports = __webpack_public_path__ + "img/information_1.26648f90.jpg";